<div id="dropTimeId">
  <app-drop-down-single-con-id [data]="horas" [valorPreSeleccionado]="horaSeleccionada" (elementoSeleccionado)="getHoras($event)"
  [width]="'50px'" [height]="'26px'"></app-drop-down-single-con-id>
  <span>:</span>
  <app-drop-down-single-con-id [data]="minutos" [valorPreSeleccionado]="minutoSeleccionado" (elementoSeleccionado)="getMinutos($event)"
  [width]="'50px'" [height]="'26px'"></app-drop-down-single-con-id>
</div>

